import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { HireOrangeDubaiIcon } from "../../../app-constants";
import { StaticImage } from "gatsby-plugin-image";

function Hiretopdevelopers() {
  return (
    <div className="hire_top_developers p-100">
      <Container>
        <Row>
          <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="">
            <h2>
              Hire Mobile App Developers Providing Versatile Services for
              Different Project Needs
            </h2>
          </Col>
          <Col
            xs={12}
            md={4}
            lg={4}
            xl={4}
            xxl={4}
            className=" offset-xl-1 offset-lg-1"
          >
            <p>
              Explore a diverse pool of talent with our comprehensive hiring
              services. Our mobile app developers in KSA offer skilled
              professionals to elevate your project to new heights. Build your
              dream team and bring your ideas to life with our expert
              development services.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={5} lg={6} xl={4} xxl={4} className="">
            <div className="hire_top_dev_box">
              <div className="hire_top_main">
                <div className="hire_top_img">
                  <StaticImage
                    src="../../images/locationgcc/hire-dubai/hire-android.png"
                    alt="hire_android"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={49}
                    height={59}
                  />
                </div>
                <div className="hire_top_head">
                  <h6>
                    Hire Android
                    <br /> Developers
                  </h6>
                </div>
              </div>
              <div className="hire_top_content">
                <p>
                  Expert Android developers ready to bring your app ideas to
                  life on the world's largest mobile platform.
                </p>
              </div>
              <div className="hire_top_btn">
                <Link to="/contact" className="" aria-label="TekRevol Contact">
                  Hire A Developer {HireOrangeDubaiIcon}
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="">
            <div className="hire_top_dev_box">
              <div className="hire_top_main">
                <div className="hire_top_img">
                  <StaticImage
                    src="../../images/locationgcc/hire-dubai/hire-ios.png"
                    alt="hire_ios"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={51}
                    height={51}
                  />
                </div>
                <div className="hire_top_head">
                  <h6>
                    Hire iOS <br /> Developers
                  </h6>
                </div>
              </div>
              <div className="hire_top_content">
                <p>
                  Skilled iOS developers to create stunning and intuitive apps
                  for Apple devices.
                </p>
              </div>
              <div className="hire_top_btn">
                <Link to="/contact" className="" aria-label="TekRevol Contact">
                  Hire IOS Developer {HireOrangeDubaiIcon}
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="">
            <div className="hire_top_dev_box">
              <div className="hire_top_main">
                <div className="hire_top_img">
                  <StaticImage
                    src="../../images/locationgcc/hire-dubai/hire-react.png"
                    alt="hire_ios"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={53}
                    height={61}
                  />
                </div>
                <div className="hire_top_head">
                  <h6>
                    Hire React Native <br /> Developers
                  </h6>
                </div>
              </div>
              <div className="hire_top_content">
                <p>
                  Talented React Native developers proficient in building
                  cross-platform mobile apps with native performance
                </p>
              </div>
              <div className="hire_top_btn">
                <Link to="/contact" className="" aria-label="TekRevol Contact">
                  Hire React Native Developer {HireOrangeDubaiIcon}
                </Link>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="">
            <div className="hire_top_dev_box">
              <div className="hire_top_main">
                <div className="hire_top_img">
                  <StaticImage
                    src="../../images/locationgcc/hire-dubai/hire-angular.png"
                    alt="hire_angular"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={57}
                    height={60}
                  />
                </div>
                <div className="hire_top_head">
                  <h6>
                    Hire AngularJSM
                    <br /> Developers
                  </h6>
                </div>
              </div>
              <div className="hire_top_content">
                <p>
                  Experienced AngularJS developers to develop dynamic and
                  interactive web applications.
                </p>
              </div>
              <div className="hire_top_btn">
                <Link to="/contact" className="" aria-label="TekRevol Contact">
                  Hire AngularJS Developers {HireOrangeDubaiIcon}
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="">
            <div className="hire_top_dev_box">
              <div className="hire_top_main">
                <div className="hire_top_img">
                  <StaticImage
                    src="../../images/locationgcc/hire-dubai/hire-laravel.png"
                    alt="hire_ios"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={62}
                    height={62}
                  />
                </div>
                <div className="hire_top_head">
                  <h6>
                    Hire Laravel
                    <br /> Developers
                  </h6>
                </div>
              </div>
              <div className="hire_top_content">
                <p>
                  Dedicated Laravel developers to build secure, scalable, and
                  feature-rich web applications.
                </p>
              </div>
              <div className="hire_top_btn">
                <Link to="/contact" className="" aria-label="TekRevol Contact">
                  Hire Laravel Developers {HireOrangeDubaiIcon}
                </Link>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="">
            <div className="hire_top_dev_box">
              <div className="hire_top_main">
                <div className="hire_top_img">
                  <StaticImage
                    src="../../images/locationgcc/hire-dubai/hire-flutter.png"
                    alt="hire_ios"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={47}
                    height={60}
                  />
                </div>
                <div className="hire_top_head">
                  <h6>
                    Hire Flutter
                    <br /> Developers
                  </h6>
                </div>
              </div>
              <div className="hire_top_content">
                <p>
                  Versatile full-stack developers to handle both front-end and
                  back-end development tasks.
                </p>
              </div>
              <div className="hire_top_btn">
                <Link to="/contact" className="" aria-label="TekRevol Contact">
                  Hire Full Stack Developers{HireOrangeDubaiIcon}
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Hiretopdevelopers;
